<template>
    <div class="word">
        <h1>{{word.term}}</h1>
        <transition name="fade" mode="out-in">
            <div v-if="showAnalogy" key="analogy">
                <p>{{word.analogy}}</p>
            </div>
            <div v-else>
                <p>{{word.explanation}}</p>
            </div>
        </transition>
        <div v-if="showAnalogy">
            <a key="analogy" href="#" @click="showAnalogy = !showAnalogy">
                View Definition</a>
        </div>
        <div v-else>
            <a key="analogy" href="#" @click="showAnalogy = !showAnalogy">View Analogy</a>
        </div>
    </div>


</template>

<script>
    export default {
        name: "Word",
        props: {
            word: {
                type: Object,
                required: true
            },
            canDisplayDefinition: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                showAnalogy: false
            }
        },
        methods: {
            // fade: function () {
            //     $('.no-display').css('opacity', 0);
            //     setTimeout(function () {
            //         $('.no-display.display').css('opacity', 1);
            //     }, 350);
            // }
        },
        mounted: function () {
            // this.fade()
        }
    }

</script>

<style scoped lang="scss">
    p {
        @media only screen and (min-width: 320px) {
            font-size: 15px;
        }
        @media only screen and (min-width: 1024px) {
            font-size: 20px;
        }
    }
    h1 {
        color: #323232;
        text-transform: uppercase;
        @media only screen and (min-width: 320px) {
            font-size: 32px;
        }
        @media only screen and (min-width: 480px) {
            font-size: 24px;
        }
        @media only screen and (min-width: 768px) {
            font-size: 32px;
        }
        @media only screen and (min-width: 1024px) {
            font-size: 40px;
        }
        @media only screen and (min-width: 1200px) {
            font-size: 50px;
        }
    }

    a {
        font-family: "Frutiger LT W01_65 Bold1475746", 'Avenir', Helvetica, Arial, sans-serif;
        text-decoration: none;
        bottom: -10px;
        color: #D40511;
        /*position: relative;*/
        &:hover {
            text-decoration: underline;
        }
        @media only screen and (min-width: 320px) {
            font-size: 15px;
        }
        @media only screen and (min-width: 480px) {
            font-size: 20px;
        }
        @media only screen and (min-width: 1024px) {
            font-size: 22px;
        }
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0
    }

    .fadeIn-enter-active, .fadeIn-leave-active {
        transition: opacity 1.5s
    }

    .fadeIn-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0
    }

</style>



// WEBPACK FOOTER //
// src/components/Word.vue